// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1K0gr","alert":"SettungsInbox_alert__3Gj1e"};